import Vue from 'vue';

const getDefaultPeopleState = () => ({
  parent: {
    firstName: '',
    lastName: '',
  },
  customerDefaultCard: {},
  child: {
    photoUrl: '',
  },
  children: {},
  message: '',
});

export default {
  state: getDefaultPeopleState(),

  actions: {
    async GET_PARENT(context, payload) {
      const request = {
        url: '/api/v4/parent/user/detail'
      };
      const mutation = 'UPDATE_PARENT';
      const options = {
        request,
        mutation,
        globalLoading: true,

      };
      return await context.dispatch('MAKE_POST_REQUEST', options);
    },

    async GET_CHILDREN(context, payload) {
      const request = {
        url: '/api/v4/people/parent/children',
      };
      const mutation = 'UPDATE_CHILDREN';

      const options = {
        request,
        mutation,
      };

      return await context.dispatch('MAKE_GET_REQUEST', options);
    },

    async GET_CHILD_BY_ID(context, payload) {
      const request = {
        url: `/api/v4/people/child/${payload}`,
      };
      const mutation = 'UPDATE_CHILD';

      const options = {
        request,
        mutation,
      };

      return await context.dispatch('MAKE_GET_REQUEST', options);
    },

    async UPDATE_PARENT_PROPERTY(context, payload) {
      const fieldName = payload.property;
      const { newValue } = payload;

      const request = {
        url: '/api/v4/people/parent/edit',
        parameters: {
          [fieldName]: newValue,
        },
      };
      const mutation = 'UPDATE_PARENT_FIELDS';
      const options = {
        request,
        mutation,
      };

      await context.dispatch('MAKE_POST_REQUEST', options);
    },
    async UPDATE_CHILD_PROPERTY(context, payload) {
      var fieldName = payload.property;
      const { newValue } = payload;
      const { childId } = payload;

      if (fieldName == 'medicalAdvice') {
        var fieldName = 'medical';
      }

      const request = await fetch('/api/v4/people/child/edit', {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({
          [fieldName]: newValue,
          childId,
        }),
      });
      // update child
      const response = await request;

      if (response.status == 200) {
        await context.commit('UPDATE_CHILD_FIELD', {
          fieldName,
          newValue,
          childId,
        });
      }
    },

    async UPLOAD_AVATAR(context, payload) {
      try {
        const url = '/api/v4/people/person/avatar';
        const request = new Request(url, {
          method: 'POST',
          credentials: 'same-origin',
          body: payload,
        });

        const response = await fetch(request);
        const json = await response.json();

        return context.commit('UPDATE_PERSON_AVATAR', json.data);
      } catch (error) {
        console.error(error);
      }
    },
  },

  mutations: {
    UPDATE_PARENT(state, payload) {
      state.parent = payload.parent;
      state.children = payload.children;
    },
    UPDATE_PARENT_FIELDS(state, payload) {
      Vue.set(state, 'parent', payload);
    },

    UPDATE_CHILDREN(state, payload) {
      state.children = payload;
    },

    UPDATE_CHILD(state, payload) {
      state.child = payload;
    },

    UPDATE_CHILD_FIELD(state, payload) {
      const { fieldName } = payload;
      state.child[fieldName] = payload.newValue;
    },

    UPDATE_PERSON_AVATAR(state, payload) {
      const person = state.children[payload.personId] || state.parent;
      Vue.set(person, 'photoUrl', payload.photoUrl);
    },

    RESET_PEOPLE_STATE(state) {
      Object.assign(state, getDefaultPeopleState());
    },
  },

  getters: {
    parent(state) {
      return state.parent;
    },
    children(state) {
      return state.children;
    },

    parentLoading(state) {
      return state.parentLoading;
    },
    childrenLoading(state) {
      return state.childrenLoading;
    },
    child(state) {
      return state.child;
    },
    customerDefaultCard(state) {
      return state.customerDefaultCard;
    },

    message(state) {
      return state.message;
    },
  },
};
